























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DxDataGrid, DxColumn, DxMasterDetail } from 'devextreme-vue/data-grid';
import { WarningCollection } from './apiTypes';
import { filterNonEmptyWarnings } from './utils';
import { defaultTableConfig } from '@/core/components/table';
import tableConfig from './tableConfig';
import WarningsDetail from './WarningsDetail.vue';
import { localize } from '@/core/filters';

@Component({
    components: {
        DxDataGrid,
        DxColumn,
        DxMasterDetail,
        WarningsDetail,
    },
})
export default class Warnings extends Vue {
    @Prop({ type: Array, required: true })
    public warnings!: WarningCollection[];

    public get nonEmptyWarnings(): WarningCollection[] {
        return filterNonEmptyWarnings(this.warnings);
    }

    public get tableConfig() {
        return {
            ...defaultTableConfig(this),
            ...tableConfig,
        };
    }

    public localize = localize;
}
